import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	TypePermissionUserPipe, StepAnalyseEnumPipe, PlantingAreaEnumPipe, DebtTypeEnumPipe,
	AnalysisStatusEnumPipe, ActionStepEnumPipe, InfoInputValueEnumPipe, RatingEnumPipe, FiscalYearEnumPipe, TypeAnalyseEnumPipe, TypeDeliveryEnumPipe
} from './enums-convert-pipe';
import { MaskCpfPipe, MaskCnpjPipe } from './mask-cpf.pipe';
import { BooleanPipe, MoedaBrPipe, PercentualPipe, InteiroPipe, NumeroPipe } from './commons-convert-pipe';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		TypePermissionUserPipe,
		StepAnalyseEnumPipe,
		MaskCpfPipe,
		MaskCnpjPipe,
		BooleanPipe,
		MoedaBrPipe,
		InteiroPipe,
		NumeroPipe,
		PercentualPipe,
		PlantingAreaEnumPipe,
		DebtTypeEnumPipe,
		AnalysisStatusEnumPipe,
		ActionStepEnumPipe,
		InfoInputValueEnumPipe,
		RatingEnumPipe,
		FiscalYearEnumPipe,
		TypeAnalyseEnumPipe,
		TypeDeliveryEnumPipe
	],
	exports: [
		TypePermissionUserPipe,
		StepAnalyseEnumPipe,
		MaskCpfPipe,
		MaskCnpjPipe,
		BooleanPipe,
		MoedaBrPipe,
		InteiroPipe,
		NumeroPipe,
		PercentualPipe,
		PlantingAreaEnumPipe,
		DebtTypeEnumPipe,
		AnalysisStatusEnumPipe,
		ActionStepEnumPipe,
		InfoInputValueEnumPipe,
		TypeAnalyseEnumPipe,
		TypeDeliveryEnumPipe
	]
})
export class SharedPipesModule { }
